module.exports = __webpack_public_path__ + "img/H-B-6-load-standup-shadow.35a0a840.png";